import React, { useState } from 'react';

import NotificationDropDown from './NotificationDropDown';

const HeaderNotification = (props) => {

    const [isNotiModalOpen, setNotiModalOpen] = useState(false);

    return (
        <>
            <div 
                className={isNotiModalOpen ? "cart-btn show-header-modal scwllink" : "cart-btn show-header-modal"} 
                onClick={() => setNotiModalOpen(!isNotiModalOpen)}
            >
                <i className={
                    props.bgColor === "color" ? 
                        "far fa-bell" :
                        props.navbar ?
                        "far fa-bell" : "far fa-bell color-white"
                    }
                ></i>  
                <span className="cart-counter red2-bg">{props.unreadNotifications}</span> 
            </div>
            {props.notifications && props.notificationDescription &&
                <NotificationDropDown
                    isNotiModalOpen={isNotiModalOpen}
                    notifications={props.notifications}
                    notificationDescriptions={props.notificationDescription}
                />
            }
        </>
    );
};

export default HeaderNotification;